export const BORDER_GAP_WIDTH = 3;
export const BORDER_GAP_DISTANCE = 8;
export const SIDE_SECTION_ENDS_DISTANCE = 40;
export const SIDE_SECTION_BORDER_WIDTH = 3;
